var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeClickablePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25V12",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.125 9.25C11.7463 9.25 12.25 8.74632 12.25 8.125C12.25 7.50368 11.7463 7 11.125 7C10.5037 7 10 7.50368 10 8.125C10 8.74632 10.5037 9.25 11.125 9.25Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.8147L8.09437 10.7194C8.16403 10.6496 8.24675 10.5943 8.33779 10.5566C8.42884 10.5188 8.52644 10.4994 8.625 10.4994C8.72356 10.4994 8.82116 10.5188 8.91221 10.5566C9.00325 10.5943 9.08597 10.6496 9.15563 10.7194L11 12.5637",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7311 16.6075C18.6878 16.5644 18.6558 16.5112 18.6377 16.4528C18.6197 16.3944 18.6162 16.3324 18.6275 16.2723C18.6389 16.2123 18.6648 16.1559 18.7029 16.1081C18.7411 16.0603 18.7904 16.0226 18.8464 15.9982L21.0219 15.1629C21.0903 15.1318 21.1477 15.081 21.1869 15.0169C21.226 14.9528 21.245 14.8785 21.2414 14.8035C21.2378 14.7285 21.2118 14.6564 21.1667 14.5963C21.1217 14.5363 21.0596 14.4911 20.9886 14.4668L13.4854 12.0166C13.4202 11.9965 13.3508 11.9946 13.2846 12.011C13.2185 12.0275 13.158 12.0616 13.1098 12.1098C13.0616 12.158 13.0275 12.2185 13.011 12.2846C12.9946 12.3508 12.9965 12.4202 13.0166 12.4854L15.4654 19.99C15.4897 20.061 15.5349 20.1231 15.5949 20.1682C15.6549 20.2132 15.7271 20.2392 15.8021 20.2428C15.8771 20.2464 15.9514 20.2274 16.0155 20.1883C16.0796 20.1491 16.1304 20.0917 16.1614 20.0233L16.9968 17.8479C17.0211 17.7918 17.0589 17.7425 17.1067 17.7044C17.1545 17.6662 17.2108 17.6403 17.2709 17.6289C17.331 17.6176 17.393 17.6211 17.4514 17.6391C17.5098 17.6572 17.5629 17.6893 17.6061 17.7325L20.0113 20.1377C20.0816 20.208 20.177 20.2474 20.2764 20.2474C20.3758 20.2474 20.4711 20.208 20.5414 20.1377L21.1363 19.5443C21.2066 19.4739 21.246 19.3786 21.246 19.2792C21.246 19.1798 21.2066 19.0844 21.1363 19.0141L18.7311 16.6075Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeClickablePurple);
export default __webpack_public_path__ + "static/media/question_type_clickable_purple.824c11c36843ecadccc5b93f0cbb81a2.svg";
export { ForwardRef as ReactComponent };